<template>
  <div class="d-flex">
    <div
      v-for="value in params.value"
      :key="value.id"
      class="flagContainer"
    >
      <VtFlags :code="value.language.locale" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VtFlags from '@/components/common/VtFlags'

export default Vue.extend({
    name: 'FlagsIcons',
    components: { VtFlags }
})

</script>

<style scoped>
    div.flagContainer {
        width: 25px !important;
    }
</style>
